import React from 'react';

/**
 * ColorPalette component
 * 
 * Displays the color palette for the new orange theme
 */
const ColorPalette = () => {
  // Color palette configuration
  const colors = [
    { name: 'Primary', hex: '#ff7a00', description: 'Main brand color' },
    { name: 'Primary Light', hex: '#ff9933', description: 'Lighter shade for hover states' },
    { name: 'Primary Dark', hex: '#e65c00', description: 'Darker shade for active states' },
    { name: 'Accent', hex: '#ffbb80', description: 'Used for highlights and accents' },
    { name: 'Background Light', hex: '#fff9f2', description: 'Light background color' },
    { name: 'Text Dark', hex: '#333333', description: 'Primary text color' },
    { name: 'Text Light', hex: '#ffffff', description: 'Text on dark backgrounds' },
  ];

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h2 style={{ marginBottom: '20px', fontSize: '24px', fontWeight: '700' }}>Orange Theme Color Palette</h2>
      
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
        {colors.map((color) => (
          <div 
            key={color.name}
            style={{ 
              width: '180px',
              borderRadius: '8px',
              overflow: 'hidden',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            }}
          >
            <div 
              style={{ 
                backgroundColor: color.hex, 
                height: '100px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: color.name === 'Text Light' || color.name === 'Primary Light' || color.name === 'Accent' ? '#333' : '#fff',
                fontWeight: '600'
              }}
            >
              {color.hex}
            </div>
            <div style={{ padding: '12px' }}>
              <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: '600' }}>{color.name}</h3>
              <p style={{ margin: '0', fontSize: '14px', color: '#666' }}>{color.description}</p>
            </div>
          </div>
        ))}
      </div>
      
      <div style={{ marginTop: '40px' }}>
        <h3 style={{ marginBottom: '15px', fontSize: '18px', fontWeight: '600' }}>Usage Guidelines</h3>
        <ul style={{ paddingLeft: '20px' }}>
          <li style={{ marginBottom: '8px' }}>Use Primary for main buttons, active states, and key UI elements</li>
          <li style={{ marginBottom: '8px' }}>Use Primary Light for hover states and secondary elements</li>
          <li style={{ marginBottom: '8px' }}>Use Background Light for section backgrounds that need subtle emphasis</li>
          <li style={{ marginBottom: '8px' }}>Maintain adequate contrast between text and backgrounds</li>
        </ul>
      </div>
    </div>
  );
};

export default ColorPalette; 